export default {
  coreWebVitals: {
    viewTitle: "Core Web Vitals",
    tabTitle: "CoreWebVitals",
    selectDomain: {
      title: "ドメインを選択",
      label: {
        client: "クライアント",
        publisher: "パブリッシャー",
        domain: "ドメイン",
      },
      reload: "更新",
    },
    deviceTab: {
      desktop: "Desktop",
      mobile: "Mobile",
    },
    noSelectDomain: "ドメインを選択してください",
    lastUpdateDate: "最終更新日: ",
    fieldData: {
      title: "実際のユーザーの環境で評価",
      subtitle: "世界中の実際のユーザーデータに基づいて、サイトのパフォーマンスを評価しています。",
      fcp: {
        title: "First Contentful Paint（FCP）",
        label: ["良好(<=1.8s)", "改善の余地あり", "不良(>3.0s)"],
      },
      fid: {
        title: "First Input Delay（FID）",
        label: ["良好(<=100ms)", "改善の余地あり", "不良(>300ms)"],
      },
      lcp: {
        title: "Largest Contentful Paint（LCP）",
        label: ["良好(<=2.5s)", "改善の余地あり", "不良(>4.0s)"],
      },
      cls: {
        title: "Cumulative Layout Shift（CLS）",
        label: ["良好(<=0.10)", "改善の余地あり", "不良(>0.25)"],
      },
      inp: {
        title: "Interaction to Next Paint（INP）",
        label: ["良好(<=200ms)", "改善の余地あり", "不良(>500ms)"],
      },
      ttfb: {
        title: "Time to First Byte（TTFB）",
        label: ["良好(<=0.8s)", "改善の余地あり", "不良(>1.8s)"],
      },
      explanation: {
        date: "過去 28 日間の収集期間",
        device: "さまざまなモバイル デバイス",
        sample: "多数のサンプル",
        cruxLinkText: "Chrome ユーザー エクスペリエンス レポート",
        cruxLinkUrl: "https://developers.google.com/web/tools/chrome-user-experience-report",
        time: "セッション全体の長さ",
        network: "さまざまなネットワーク接続",
        chrome: "すべての Chrome バージョン",
      },
    },
    labData: {
      title: "パフォーマンスの問題を診断する",
      subtitle:
        "シミュレートした環境でサイトを読み込んで、詳しい分析情報や改善の提案を確認できます。",
      score: {
        title: "パフォーマンススコア",
        goodScore: "90 - 100",
        needsImprovementScore: "60 - 89",
        poorScore: "0 - 59",
      },
      fcp: {
        title: "First Contentful Paint（FCP）",
        explanation:
          "First Contentful Paint（FCP）は、テキストまたは画像が初めてペイントされるまでにかかった時間です。",
      },
      tti: {
        title: "Time to Interactive（TTI）",
        explanation:
          "Time to Interactive（TTI）は、ページが完全に操作可能になるのに要する時間です。",
      },
      si: {
        title: "Speed Index（SI）",
        explanation:
          "Speed Index（SI）は、ページのコンテンツが取り込まれて表示される速さを表します。",
      },
      tbt: {
        title: "Total Blocking Time（TBT）",
        explanation:
          "Total Blocking Time（TBT）は、タスクの処理時間が 50 ミリ秒を上回った場合の、コンテンツの初回描画から操作可能になるまでの合計時間（ミリ秒）です。",
      },
      lcp: {
        title: "Largest Contentful Paint（LCP）",
        explanation:
          "Largest Contentful Paint（LCP）は、最も大きなテキストまたは画像が描画されるまでにかかった時間です。",
      },
      cls: {
        title: "Cumulative Layout ​Shift（CLS）",
        explanation:
          "Cumulative Layout ​Shift（CLS）は、ビューポート内の視覚要素がどのくらい移動しているかを測定する指標です。",
      },
      explanation: {
        date: "Captured at ",
        sample: "1回のページ読み込み",
        time: "最初のページ読み込み",
      },
    },
    reportExecution: {
      title: "レポート出力",
    },
    cwvDomains: {
      buttonTitle: "登録ドメイン一覧",
      viewTitle: "Domains",
      tabTitle: "CoreWebVitals_Domains",
      filterByPublisher: {
        title: "パブリッシャーで絞り込む",
        label: "パブリッシャー",
        loading: "Loading",
        noData: "No data available",
        reload: "更新",
      },
      search: {
        label: "ドメイン名で検索",
      },
      tableHeaders: {
        domain: "ドメイン名",
        publisher: "パブリッシャー",
        createdAt: "作成日",
      },
      notify: {
        success: {
          save: "ドメインの保存に成功しました",
          delete: "ドメインを削除しました",
        },
        error: {
          failedSave: "ドメインの保存に失敗しました",
          failedDelete: "ドメインの削除に失敗しました",
        },
      },
      rules: {
        notes: {
          maxRecordCount: "1パブリッシャーにつき10件まで登録可能です",
          noDuplicate: "1パブリッシャーに対し同名のドメインを複数登録することはできません",
        },
        tooltip: {
          domainNameFormat: {
            maxLength: "255文字以内",
            startWith: "必ず http:// または https:// で開始",
            notEndWith: "最後の文字にドット（.）は指定不可",
            type: "日本語、英数字（半角全角問わず）、一部記号が使用可能",
            noEmoji: "絵文字は使用不可",
          },
        },
      },
      create: {
        buttonTitle: "New Domain",
        cardTitle: "Core Web Vitals ドメイン新規作成",
        label: {
          domainName: "ドメイン名",
          publisher: "パブリッシャー",
        },
        publishers: {
          loading: "Loading",
          noData: "No data available",
        },
      },
      edit: {
        buttonTitle: "編集",
        cardTitle: "Core Web Vitals ドメイン編集",
        label: {
          domainName: "ドメイン名",
          publisher: "パブリッシャー",
        },
        publishers: {
          loading: "Loading",
          noData: "No data available",
        },
      },
      delete: {
        buttonTitle: "削除",
        dialog: {
          title: "確認",
          text: "ドメインを削除します",
        },
      },
    },
  },
};
